var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.layoutName === 'default')?_c('Default',{staticClass:"layout-default"}):(_vm.layoutName === 'blank')?_c('Blank',{staticClass:"layout-blank"}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }